<!-- /news page frame: the list, never wider than the standard page text, and the archive
     (years and months) in a column on the right; on narrow screens, after the list -->

<template>
  <div class="news-layout" :class="{hasSideColumn}">
    <div class="news-content"><slot /></div>
    <!-- narrow screens: the years are a full-screen picker from the breadcrumb (YearPicker) -->
    <NewsArchive v-if="hasSideColumn" class="news-archive" />
  </div>
</template>

<script setup>
import {computed, inject} from "vue";
import NewsArchive from "@/components/News/Archive.vue";

const displayWidth = inject("displayWidth"); // narrow | medium | wide | unlimited
const hasSideColumn = computed(() => displayWidth.value !== "narrow");
</script>

<style scoped>
/* the page (<body>, display: inline-block in App.vue) sizes itself to its widest unbreakable
   content; one-line previews (nowrap) would stretch it far past the screen. inline-size
   containment keeps the news area out of that: it takes the page's width, and fits inside it */
.news-layout {
  contain: inline-size;
  /* so its width is set here instead: the full page (body max 56rem, less <main>'s 1rem sides),
     or the screen on smaller ones (less <main>'s padding: 1rem, 0.8rem on narrow screens) */
  width: min(54rem, calc(100vw - 2rem));
}
.narrow .news-layout {
  width: min(54rem, calc(100vw - 1.6rem));
}
.news-layout.hasSideColumn {
  display: grid;
  /* the list takes what it can (a 600px email fits beside the archive at full page width) */
  grid-template-columns: minmax(0, 1fr) 8rem;
  gap: 1.25rem;
  /* the columns' first lines share a baseline: "News" (and "Collapse all") with "Year" */
  align-items: baseline;
}
.news-content {
  min-width: 0; /* a wide email can't push the column past the page text width */
}
.news-layout:not(.hasSideColumn) .news-archive {
  margin-top: 2.5rem;
}
</style>

<!-- global, loaded once here for every news page: the "News" heading and the black body panel -->
<style src="./heading.css"></style>
<style src="./message.css"></style>
